import { Puzzle } from "./Game";

export const hardCodedPractice : Record<number, Puzzle> = {
}